<div class="classificationContainer">
  <p class="instruction">這張臉顯示出甚麼情緒？</p>
  <div class="choicesContainer">
    <div
      class="choice"
      *ngFor="let choice of choices"
      (click)="onChoiceClicked(choice)"
    >
      {{ choice }}
    </div>
  </div>
</div>
